export default {"src":"/_next/static/media/angle-right.839c8eb5.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};